const STORAGE_KEY = 'dicepit_tutorial_done';

/**
 * Check if the tutorial has been completed/skipped.
 * Used by the multiplayer gate.
 */
export const isTutorialCompleted = (): boolean => {
    return localStorage.getItem(STORAGE_KEY) !== null;
};

/**
 * Mark tutorial as completed.
 */
export const markTutorialCompleted = (): void => {
    localStorage.setItem(STORAGE_KEY, 'completed');
};

/**
 * Mark tutorial as skipped (used from multiplayer gate).
 */
export const markTutorialSkipped = (): void => {
    localStorage.setItem(STORAGE_KEY, 'skipped');
};
